import request from '@/utils/request'

export default {
    checkReferralCode: async({ commit }, referralCode) => {
        await request({ method: 'get', url: '/account/referral-code', params: { referralCode }})
            .then(res => {
                if (res.data && res.data.referralCode) {
                    commit('businessRegister/SET_REFERRAL_CODE', res.data.referralCode, { root: true })
                    commit('businessRegister/SET_REF_STATUS', 'validCode', { root: true })
                } else {
                    commit('businessRegister/SET_REF_STATUS', 'invalidCode', { root: true })
                }
            })
    },

    registerBussiness: async({ dispatch, commit }, data) => {
        await request({ method: 'post', url: '/account/business', data: { ...data }})
            .then(res => {
                if (res.data) {
                    commit('businessRegister/SET_REF_STATUS', 'confirmation', { root: true })
                }
            })
            .catch(error => {
                if (error.response && error.response.data && error.response.data.statusDescription) {
                    dispatch('addMessage', {
                        type: 'error',
                        message: error.response.data.statusDescription
                    }, { root: true })
                }
            })
    },

    confirmRegsiter: async({ commit }, params) => {
        await request({ method: 'get', url: `/account/confirmation/${params.referralCode}/${params.confirmationCode}` })
            .then(res => {
                if (res.data && res.data.confirmed) {
                    commit('businessRegister/SET_REF_STATUS', 'registered', { root: true })
                }
            })
            .catch(_ => {
                commit('businessRegister/SET_REF_STATUS', 'invalidCode', { root: true })
            })
    }
}
